import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import Header from '../layout/Header';

const LandingPage = () => {
  // Using Link component instead of navigate for better compatibility
  // This ensures the routing works properly even if there are issues with useNavigate

  return (
    <div className="landing-page">
      <Header variant="landing" />

      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Navigate Your Federal Career & Retirement</h1>
            <p className="subtitle">Calculate your GS salary progression, TSP growth, and pension benefits. Compare scenarios and optimize your entire federal career trajectory.</p>
            
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">$1M+</span>
                <span className="stat-label">Average FERS Lifetime Value</span>
              </div>
              <div className="stat">
                <span className="stat-number">30+</span>
                <span className="stat-label">Retirement Scenarios</span>
              </div>
              <div className="stat">
                <span className="stat-number">5min</span>
                <span className="stat-label">To Complete Analysis</span>
              </div>
            </div>

            <Link to="/app" className="cta-button">Get Started - Free Analysis</Link>
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <h2 className="section-title">Everything You Need for Your Federal Career & Retirement</h2>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">💵</div>
              <h3>GS Salary Calculator</h3>
              <p>Track your current pay and project future earnings across different GS levels, steps, and locality adjustments.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>FERS Pension Calculator</h3>
              <p>Calculate your exact FERS annuity payments based on your years of service, high-3 average, and retirement age.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>TSP Growth Projections</h3>
              <p>See how your TSP balance will grow with different contribution rates, matching, and investment strategies.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🏛️</div>
              <h3>Social Security Integration</h3>
              <p>Understand how Social Security coordinates with your FERS benefits and optimal claiming strategies.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">⚖️</div>
              <h3>Scenario Comparison</h3>
              <p>Compare different career paths, retirement dates, and contribution strategies side-by-side.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Visual Reports</h3>
              <p>Easy-to-understand charts and graphs showing your retirement income timeline and projections.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="trust">
        <div className="container">
          <h2 className="section-title">Made by Feds, for Feds</h2>
          <div className="trust-badges">
            <div className="trust-badge">
              <div className="trust-icon">✓</div>
              <span>100% Free</span>
            </div>
            <div className="trust-badge">
              <div className="trust-icon">✓</div>
              <span>Accurate FERS Rules</span>
            </div>
            <div className="trust-badge">
              <div className="trust-icon">✓</div>
              <span>No Login Required</span>
            </div>
            <div className="trust-badge">
              <div className="trust-icon">✓</div>
              <span>Privacy Protected</span>
            </div>
          </div>
        </div>
      </section>

      <section className="final-cta">
        <div className="container">
          <h2>Ready to Plan Your Federal Future?</h2>
          <p>Map out your entire career path, optimize retirement timing, and maximize your benefits.</p>
          <Link to="/app" className="cta-button">Launch FERS Navigator</Link>
        </div>
      </section>

      <footer>
        <div className="container">
          <p>© 2025 FERS Navigator - The Federal Employee Retirement Calculator</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
